import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { InvoiceTemplateArchivedFilter } from "@common/types/invoiceTemplate";
import { View } from "@common/types/views/views";
import { InvoiceTemplateView } from "@common/types/views/invoiceTemplateViews";
import { EntityFilterCombobox } from "@components/entity/EntityFilter/EntityFilterCombobox";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { ColumnSettings } from "@design-system/ViewToolbar/ColumnSettings";
import { TablePageHeader } from "../../pageHeader/TablePageHeader";
import { FilterTabs, FiltersChangeFn } from "../../pageHeader/filters/lib";
import { CreateInvoiceTemplateMenu } from "./CreateInvoiceTemplateMenu";
import {
    defaultInvoiceTemplateView,
    invoiceTemplatesViewConfig,
} from "./invoiceTemplatesViewConfig";

const ARCHIVED_FILTER_LABELS: Record<InvoiceTemplateArchivedFilter, string> = {
    [InvoiceTemplateArchivedFilter.ACTIVE]: "Active",
    [InvoiceTemplateArchivedFilter.ALL]: "All",
    [InvoiceTemplateArchivedFilter.ARCHIVED]: "Archived",
};

const ARCHIVED_FILTER_ITEMS: Array<
    PickerItemData<InvoiceTemplateArchivedFilter>
> = [
    InvoiceTemplateArchivedFilter.ACTIVE,
    InvoiceTemplateArchivedFilter.ALL,
    InvoiceTemplateArchivedFilter.ARCHIVED,
].map((option) => ({ value: option, label: ARCHIVED_FILTER_LABELS[option] }));

const AVAILABLE_FILTERS = [
    FilterTabs.COUNTERPARTY,
    FilterTabs.TEMPLATE_CREATED_BY,
];

interface Props {
    search: string;
    setSearch: (search: string) => void;
    filters: Pick<
        FiltersTypes,
        | "entityIds"
        | "counterpartiesIds"
        | "withEmptyOrUnverifiedCounterparty"
        | "hasCounterparty"
        | "invoiceTemplateCreatedByUserIds"
    >;
    onFiltersChange: FiltersChangeFn;
    archivedFilter: InvoiceTemplateArchivedFilter;
    onArchivedFilterChange: (filter: InvoiceTemplateArchivedFilter) => void;
    view: InvoiceTemplateView;
    onViewChange: (view: View) => void;
    onCreateNew: () => void;
    onCreateFromInvoice: () => void;
}

export const InvoiceTemplatesListHeader: React.FC<Props> = ({
    search,
    setSearch,
    filters,
    onFiltersChange,
    archivedFilter,
    onArchivedFilterChange,
    view,
    onViewChange,
    onCreateNew,
    onCreateFromInvoice,
}) => (
    <TablePageHeader
        filters={filters}
        onFiltersChange={onFiltersChange}
        search={search}
        onSearchChange={(value) => setSearch(value ?? "")}
        availableFilters={AVAILABLE_FILTERS}
        counterpartyEntityLabel="Customer"
        hideClearButton
        isFullPage
    >
        <EntityFilterCombobox
            filters={filters}
            onChange={onFiltersChange}
            onlyBusiness
        />
        <Picker.Select
            items={ARCHIVED_FILTER_ITEMS}
            value={archivedFilter}
            onValueChange={(value) => {
                if (value) {
                    onArchivedFilterChange(value);
                }
            }}
        />
        <ColumnSettings
            view={view}
            onViewChange={onViewChange}
            viewConfig={invoiceTemplatesViewConfig}
            defaultView={defaultInvoiceTemplateView}
        />
        <CreateInvoiceTemplateMenu
            onCreateNew={onCreateNew}
            onCreateFromInvoice={onCreateFromInvoice}
        />
    </TablePageHeader>
);
